import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Flex, FocusLock, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, mode, Text, Textarea, theme, Tooltip, useColorMode } from '@abb/uikit';
import { services } from 'config/services';
import { useDependencies } from 'hooks';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import StarIcon from 'shared-components/icons/StarIcon';
import { pxToRem } from 'utils/pxToRem';
export function Survey() {
    const { t } = useTranslation('common');
    const { httpClient, surveyService } = useDependencies();
    const [csiId, setCsId] = useState(null);
    const [showSurvey, setShowSurvey] = useState(false);
    useEffect(()=>{
        if (surveyService) {
            surveyService.setShowSurvey = setShowSurvey;
            surveyService.csiIdSetter = setCsId;
        }
    }, [
        csiId,
        surveyService === null || surveyService === void 0 ? void 0 : surveyService.getCsiIdSetter
    ]);
    const [isOpen, setIsOpen] = useState(true);
    const [textareaValue, setTextareaValue] = useState('');
    const [starsFilled, setStarsFilled] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [overlay, setOverlay] = useState(false);
    const { colorMode } = useColorMode();
    const tooltipLabel = {
        0: t('csi.insufficient'),
        1: t('csi.unsatisfy'),
        2: t('csi.satisfactory'),
        3: t('csi.good'),
        4: t('csi.excellent')
    };
    const handleClose = ()=>{
        setIsOpen(false);
        setShowSurvey(false);
        setOverlay(true);
    };
    const handleTextareaChange = (event)=>{
        setTextareaValue(event.target.value);
    };
    const handleFill = (index)=>{
        setStarsFilled(index + 1);
    };
    const handleRate = async ()=>{
        setIsLoading(true);
        const payload = {
            rate: starsFilled,
            feedback: textareaValue
        };
        try {
            await httpClient.post(`${services.survey}/${csiId}`, payload);
            setIsLoading(false);
            setTextareaValue('');
            setStarsFilled(0);
            handleClose();
        } catch (err) {
            console.log(err);
            setIsLoading(false);
            handleClose();
        }
    };
    if (!showSurvey) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: isOpen,
        onClose: handleClose,
        closeOnOverlayClick: overlay,
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {
                zIndex: theme.zIndices.modal + 1
            }),
            /*#__PURE__*/ _jsxs(ModalContent, {
                containerProps: {
                    zIndex: theme.zIndices.modal + 1
                },
                bg: mode('white', '#1f1f1f')({
                    colorMode
                }),
                children: [
                    /*#__PURE__*/ _jsxs(ModalHeader, {
                        fontWeight: 600,
                        fontSize: pxToRem(20),
                        children: [
                            t('csi.rate'),
                            /*#__PURE__*/ _jsx(Text, {
                                fontWeight: 400,
                                fontSize: pxToRem(14),
                                children: t('csi.sent_only_once')
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ModalCloseButton, {
                        bg: mode('#EDEDED', 'rgba(41, 41, 41, 0.90)')({
                            colorMode
                        }),
                        color: mode('black', 'white')({
                            colorMode
                        })
                    }),
                    /*#__PURE__*/ _jsxs(ModalBody, {
                        p: "0",
                        children: [
                            /*#__PURE__*/ _jsx(Flex, {
                                p: `${pxToRem(24)} ${pxToRem(21)}`,
                                bg: mode('#F7F7F7', '#313131')({
                                    colorMode
                                }),
                                gap: pxToRem(20),
                                justifyContent: "space-around",
                                children: Array(5).fill(0).map((_, index)=>{
                                    const label = tooltipLabel[`${index}`];
                                    return /*#__PURE__*/ _jsx(Box, {
                                        children: /*#__PURE__*/ _jsx(Tooltip, {
                                            hasArrow: true,
                                            label: label,
                                            bg: "#000000",
                                            color: "white",
                                            placement: "top",
                                            fontSize: pxToRem(14),
                                            fontWeight: 400,
                                            children: /*#__PURE__*/ _jsx(Flex, {
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: pxToRem(64),
                                                height: pxToRem(64),
                                                borderRadius: 100,
                                                bg: "white",
                                                children: /*#__PURE__*/ _jsx(StarIcon, {
                                                    onClick: ()=>handleFill(index),
                                                    color: index < starsFilled ? '#FFAD0A' : 'none'
                                                })
                                            })
                                        })
                                    }, index);
                                })
                            }),
                            starsFilled >= 1 && starsFilled <= 3 ? /*#__PURE__*/ _jsxs(Box, {
                                p: `${pxToRem(24)} ${pxToRem(20)}`,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSize: pxToRem(16),
                                        fontWeight: 500,
                                        mb: pxToRem(8),
                                        children: t('csi.feedback_label')
                                    }),
                                    /*#__PURE__*/ _jsx(Box, {
                                        p: "0",
                                        sx: {
                                            '& .textarea::placeholder': {
                                                color: mode('#7f7f7f', '#d2d2d2')({
                                                    colorMode
                                                })
                                            }
                                        },
                                        children: /*#__PURE__*/ _jsx(FocusLock, {
                                            children: /*#__PURE__*/ _jsx(Textarea, {
                                                onChange: handleTextareaChange,
                                                value: textareaValue,
                                                placeholder: t('csi.add_comment'),
                                                className: "textarea"
                                            })
                                        })
                                    })
                                ]
                            }) : starsFilled >= 4 && starsFilled <= 5 ? /*#__PURE__*/ _jsxs(Box, {
                                p: `${pxToRem(24)} ${pxToRem(20)}`,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSize: pxToRem(16),
                                        fontWeight: 500,
                                        mb: pxToRem(8),
                                        children: t('csi.appreciated')
                                    }),
                                    /*#__PURE__*/ _jsx(Box, {
                                        p: "0",
                                        sx: {
                                            '& .textarea::placeholder': {
                                                color: mode('#7f7f7f', '#d2d2d2')({
                                                    colorMode
                                                })
                                            }
                                        },
                                        children: /*#__PURE__*/ _jsx(FocusLock, {
                                            children: /*#__PURE__*/ _jsx(Textarea, {
                                                onChange: handleTextareaChange,
                                                value: textareaValue,
                                                placeholder: t('csi.add_feedback'),
                                                className: "textarea"
                                            })
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ModalFooter, {
                        boxShadow: "none",
                        borderTop: "1px solid rgba(23, 23, 23, 0.1)",
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "solid",
                            isDisabled: starsFilled === 0,
                            onClick: handleRate,
                            isLoading: isLoading,
                            children: t('csi.approve')
                        })
                    })
                ]
            })
        ]
    });
}
